import React from 'react';
import { useBackTarget } from '../../modules/pricingJourney/navigation';
import PageHeader from '../../modules/pricingJourney/components/PageHeader';

interface OperationsDetailHeaderProps {
  eyebrow: string;
  title: string;
  description: string;
  action?: React.ReactNode;
}

// PRC-032: pantallas de Operaciones con la cabecera común.
const OperationsDetailHeader: React.FC<OperationsDetailHeaderProps> = ({
  eyebrow,
  title,
  description,
  action,
}) => {
  // PRC-027: vuelve al origen (p. ej. Primeros pasos); sin origen, a Operaciones.
  const back = useBackTarget('/operations');

  return (
    <PageHeader
      eyebrow={eyebrow}
      title={title}
      description={description}
      back={{ label: back.label, onClick: back.go }}
      actions={action}
    />
  );
};

export default OperationsDetailHeader;
